import { InferGetStaticPropsType } from 'next'
import getBuilderPageContent from '@/src/common/queries/getBuilderPageContent'
import prisma from '@/lib/prisma'
import { MEDIUM_TYPE_PHYSICAL } from '@/prisma/schemaConstants'
import pick from 'lodash/pick'
import VisaGiftBoxFlow from '@/src/modules/gift-box/VisaGiftBoxFlow'
import getDefaultCardCategories from '@/src/common/queries/getDefaultCardCategories'
import { visaGiftBoxCategory } from '@/src/modules/build-a-card/constants'
import { PerfectGiftBoxProvider } from '@/src/common/contexts/PerfectGiftBoxContext'
import { BOX_URL } from '@/src/modules/checkout/strings'
import { getBuilderBannersOrPromos } from '@/src/common/queries/getBuilderBannersOrPromos'

const VisaGiftCardBoxPage = (
    props: InferGetStaticPropsType<typeof getStaticProps>
) => {
    return (
        <PerfectGiftBoxProvider
            predesigns={props?.predesigns}
            defaultImage={props?.defaultImage}
            //@ts-ignore
            product={props?.product}
        >
            <VisaGiftBoxFlow />
        </PerfectGiftBoxProvider>
    )
}

export async function getStaticProps() {
    const { content } = await getBuilderPageContent({
        params: {
            page: [BOX_URL],
        },
    })

    // get the default card placeholder if there is one
    let defaultCardImageFromBuilder = ''
    const { builderData } = await getDefaultCardCategories()
    builderData?.map((item) => {
        if (item.category === visaGiftBoxCategory) {
            defaultCardImageFromBuilder = item.imageUrl
        }
    })

    // Fetch data from database
    const product = await prisma.product.findFirstOrThrow({
        where: {
            brand: { brand_name: 'Visa' },
            medium: { medium_type: MEDIUM_TYPE_PHYSICAL },
        },
        include: {
            brand: {
                include: {
                    predesigns: {
                        include: {
                            design_categories: true,
                        },
                    },
                },
            },
            medium: {
                select: {
                    medium_name: true,
                    medium_type: true,
                },
            },
            ProviderProduct: {
                include: {
                    provider: true,
                },
            },
        },
    })

    const predesigns = await prisma.predesign.findMany({
        where: {
            brand_id: product.brand_id,
            medium: { medium_type: MEDIUM_TYPE_PHYSICAL },
            enabled: true,
        },
        orderBy: {
            priority: {
                sort: 'asc',
                nulls: 'last',
            },
        },
        include: {
            design_categories: true,
        },
    })

    const { consumerData: consumerBanner } = await getBuilderBannersOrPromos(
        true
    )

    // Pass data to the page via props
    return {
        props: {
            showHeader: true,
            content,
            consumerBanner,
            defaultImage: defaultCardImageFromBuilder,
            product: pick(product, [
                'uuid',
                'catalog_image',
                'template_image',
                'brand.brand_name',
                'medium.medium_name',
                'medium.medium_type',
            ]),
            predesigns: predesigns.map((predesign) => {
                return {
                    uuid: predesign.uuid,
                    design_name: predesign.design_name,
                    preview_image_url: predesign.preview_image_url,
                    categories: predesign.design_categories.map(
                        (category) => category.design_category_name
                    ),
                }
            }),
        },
        revalidate: 30,
    }
}

export default VisaGiftCardBoxPage
